/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Signoutall2Inputs */

const zh_danger_signoutall2 = /** @type {(inputs: Danger_Signoutall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出所有设备`)
};

const en_danger_signoutall2 = /** @type {(inputs: Danger_Signoutall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Out All Devices`)
};

const es_danger_signoutall2 = /** @type {(inputs: Danger_Signoutall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión en todos los dispositivos`)
};

/**
* | output |
* | --- |
* | "Sign Out All Devices" |
*
* @param {Danger_Signoutall2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_signoutall2 = /** @type {((inputs?: Danger_Signoutall2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Signoutall2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_signoutall2(inputs)
	if (locale === "en") return en_danger_signoutall2(inputs)
	return es_danger_signoutall2(inputs)
});
export { danger_signoutall2 as "danger_signOutAll" }